// import styles
import "./Spesa.css";

// import pacchetti
import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { timestamp, filesCloud } from "../../firebase/config";
import { useNavigate } from "react-router-dom";
import Resizer from "react-image-file-resizer";

// import hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";
import { useCollection } from "../../hooks/useCollection";

const metodiPagamentoLocal = [
  { value: "Nota Spese", label: "Nota Spese" },
  { value: "CC Giuvi", label: "Addebito su CC Giuvi" },
  { value: "Carta Giuvi", label: "Carta di credito Giuvi" },
  { value: "Bancomat Giuvi", label: "Bancomat Giuvi" },
];

// const settoriLocal = [
//   { value: "md", label: "MD" },
//   { value: "bi", label: "BI" },
//   { value: "cuc", label: "CUC" },
//   { value: "fv", label: "FV" },
//   { value: "plm", label: "PLM" },
//   { value: "bk", label: "BK" },
//   { value: "cod", label: "COD" },
//   { value: "ch", label: "CH" },
//   { value: "brt", label: "BRT" },
//   { value: "stm", label: "STM" },
//   { value: "robi", label: "ROBY" },
// ];

export default function Create() {
  const navigazione = useNavigate();
  const { user } = useAuthContext();
  const { addDocument, response } = useFirestore("spese");
  const { documents } = useCollection("settori");
  const { documents: projectsData } = useCollection("projects");

  // state per gestire i valori degli input
  const [nome, setNome] = useState("");
  const [dettagli, setDettagli] = useState("");
  const [cantiere, setCantiere] = useState("");
  const [importo, setImporto] = useState("");
  const [data, setData] = useState("");
  const [pagamento, setPagamento] = useState(null);
  const [foto, setFoto] = useState(null);
  const [settore, setSettore] = useState(null);
  const [fotoError, setFotoError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [settori, setSettori] = useState(null);
  const [progetti, setProjetti] = useState(null);
  const galleryInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  useEffect(() => {
    if (documents) {
      const options = documents.map((settore) => {
        return {
          value: settore.nome,
          label: settore.nome,
        };
      });
      setSettori(options);
    }
  }, [documents]);

  useEffect(() => {
    if (projectsData) {
      const options = projectsData
        .filter((project) => !project.archived)
        .map((project) => {
          return {
            value: project.id,
            label: `${project.categoria} - ${project.nome}`,
            categoria: project.categoria,
          };
        });
      setProjetti(options);
    }
  }, [projectsData]);

  // Funzione per gestire la selezione del cantiere e assegnare automaticamente il settore
  const handleCantiereChange = (selectedOption) => {
    console.log("🏗️ Cantiere selezionato:", selectedOption);
    setCantiere(selectedOption);
    if (selectedOption && selectedOption.categoria) {
      console.log(
        "✅ Settore assegnato automaticamente dalla categoria:",
        selectedOption.categoria,
      );
      // Trova il settore corrispondente nelle opzioni dei settori
      const settoreCorrispondente = settori?.find(
        (s) => s.value === selectedOption.categoria,
      );
      if (settoreCorrispondente) {
        setSettore(settoreCorrispondente);
      }
    } else {
      console.log("❌ Nessuna categoria trovata, campo settore svuotato");
      setSettore(null);
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1080,
        1080,
        "JPEG",
        75,
        0,
        (uri) => {
          resolve(uri);
        },
        "file",
      );
    });

  const buildUniqueImageName = (file, uid) => {
    const extFromType = file?.type?.split("/")?.[1];
    const extFromName = file?.name?.includes(".")
      ? file.name.split(".").pop()
      : null;
    const ext = (extFromType || extFromName || "jpg").toLowerCase();
    const safeUid = uid || "anon";
    const randomChunk = Math.random().toString(36).slice(2, 10);
    return `spesa_${safeUid}_${Date.now()}_${randomChunk}.${ext}`;
  };

  const ridimensiona = async (file) => {
    try {
      const image = await resizeFile(file);
      const uniqueName = buildUniqueImageName(file, user?.uid);
      const renamedImage = new File([image], uniqueName, {
        type: image?.type || "image/jpeg",
      });
      setFoto(renamedImage);
      setFotoError(null);
    } catch (err) {
      console.log(err);
      setFotoError("Errore durante la preparazione dell'immagine");
    }
  };

  const handleFileChange = async (e) => {
    setFoto(null);
    let selected = e.target.files[0];
    console.log(selected);
    if (!selected) {
      setFotoError("Inserisci un file");
      return;
    }
    if (!selected.type.includes("image")) {
      setFotoError("Il file selezionato dev'essere un'immagine");
      return;
    }
    await ridimensiona(selected);

    //  if (selected.size > 100000) {
    //  setFotoError("l'immagine dev'essere più piccola di 100kb");
    //return;
    // }
    // const reader = new FileReader();
    // reader.readAsDataURL(selected);
    // reader.onload = function (e) {
    //   const imgElement = document.createElement("img");
    //   imgElement.src = e.target.result;
    //   imgElement.onload = function (event) {
    //     const canvas = document.createElement("canvas");
    //     const maxWidth = 400;
    //     const scaleSize = maxWidth / event.target.width;
    //     canvas.width = maxWidth;
    //     canvas.height = event.target.height * scaleSize;
    //     const ctx = canvas.getContext("2d");
    //     ctx.drawImage(event.target, 0, 0, canvas.width, canvas.height);
    //     const srcEncoded = ctx.canvas.toDataURL(event.target, "image/jpeg");
    //     console.log(canvas);
    //     console.log(srcEncoded);
    //     setFotoError(null);
    //     setFoto(srcEncoded);
    //   };
    // };
    console.log("Immagine autorizzata");
  };

  // const uploadFoto = async (foto) => {
  //   // upload foto spesa. creiamo il percorso in cui salvare il file
  //   const uploadPath = `spese/${user.uid}/${foto.name}`;
  //   // funzione asincrona, utilizziamo ref passando come argomento il percorso e utilizziamo il metodo put per caricare
  //   const image = await filesCloud.ref(uploadPath).put(foto);
  //   console.log(image);
  //   // recuperiamo l'URL dell'immagine appena caricata NON FUNZIONA!!!!
  //   const imageUrl = await image.ref.getDownloadURL();
  //   console.log(imageUrl);
  //   setFotoUrl(imageUrl);
  //   // updateDocument(id, {
  //   //   fotoUrl: imageUrl,
  //   // });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);
    if (!pagamento) {
      setFormError("Selezione un metodo di pagamento");
      return;
    }
    if (!settore) {
      setFormError(
        "Seleziona un cantiere per assegnare automaticamente il settore",
      );
      return;
    }
    if (!foto) {
      setFormError("Inserisci una foto della spesa");
      return;
    }

    const autore = {
      displayName: user.displayName,
      photoURL: user.photoURL,
      id: user.uid,
    };

    // upload foto spesa. creiamo il percorso in cui salvare il file
    const uploadPath = `spese/${user.uid}/${buildUniqueImageName(
      foto,
      user.uid,
    )}`;
    // funzione asincrona, utilizziamo ref passando come argomento il percorso e utilizziamo il metodo put per caricare
    const image = await filesCloud.ref(uploadPath).put(foto);
    // console.log(image);
    // recuperiamo l'URL dell'immagine appena caricata NON FUNZIONA!!!!
    const imageUrl = await image.ref.getDownloadURL();
    //console.log(imageUrl);

    const spesaObj = {
      nome,
      dettagli,
      cantiere: cantiere ? cantiere.label : "",
      importo,
      pagamento: pagamento.value,
      settore: settore.value,
      data: timestamp.fromDate(new Date(data)),
      fotoUrl: imageUrl,
      autore,
    };
    console.log(spesaObj);
    addDocument(spesaObj);
  };

  useEffect(() => {
    if (response.success) {
      navigazione("/spese");
    }
  }, [response.success, navigazione]);

  return (
    <div className="create-form">
      <h2 className="page-title">Nuova Spesa</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Nome Fornitore:</span>
          <input
            required
            type="text"
            onChange={(e) => setNome(e.target.value)}
            value={nome}
          />
        </label>
        <label>
          <span>Ulteriori dettagli:</span>
          <input
            required
            type="textarea"
            onChange={(e) => setDettagli(e.target.value)}
            value={dettagli}
          />
        </label>
        <label>
          <span>Cantiere di riferimento:</span>
          <Select
            value={cantiere}
            onChange={handleCantiereChange}
            options={progetti}
            placeholder="Seleziona un cantiere"
            isClearable
            isSearchable
          />
        </label>
        <label>
          <span>Importo:</span>
          <input
            required
            type="number"
            onChange={(e) => setImporto(e.target.value)}
            value={importo}
          />
        </label>
        <label>
          <span>Data:</span>
          <input
            required
            type="date"
            onChange={(e) => setData(e.target.value)}
            value={data}
          />
        </label>
        <label>
          <span>Modalità di pagamento:</span>
          <Select
            onChange={(option) => setPagamento(option)}
            options={metodiPagamentoLocal}
            isSearchable={false}
          />
        </label>
        <label>
          <span>Macro Settore:</span>
          <input
            type="text"
            value={settore ? settore.label || settore.value : ""}
            readOnly
            placeholder="Seleziona prima un cantiere"
            style={{
              backgroundColor: "#f8f9fa",
              cursor: "not-allowed",
              color: "#6c757d",
            }}
          />
        </label>
        <label>
          <span>Foto:</span>
          <div className="photo-actions">
            <button
              type="button"
              className="btn outline"
              onClick={() => cameraInputRef.current?.click()}
            >
              Scatta foto
            </button>
            <button
              type="button"
              className="btn outline-secondary"
              onClick={() => galleryInputRef.current?.click()}
            >
              Scegli da galleria
            </button>
          </div>
          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <input
            ref={galleryInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {foto && (
            <div style={{ marginTop: "8px", fontSize: "0.9rem" }}>
              File selezionato: {foto.name}
            </div>
          )}
          {fotoError && <div className="error">{fotoError}</div>}
        </label>
        <button className="btn primary block">Inserisci Spesa</button>
        {formError && <p className="error">{formError}</p>}
      </form>
      <br />
    </div>
  );
}
